// extracted by mini-css-extract-plugin
export default {"project":"project-viewer_project__eOx0a","rightSide":"project-viewer_rightSide__kbnnm","half":"project-viewer_half__AEt2H"};